




































































import { ActualiteDTO } from "@/model/bean/GeneratedDTOs"
import BookmarkCard from "@/views/generic_components/BookmarkCard.vue"
import { Component, Prop, Vue } from "vue-property-decorator"
import { format } from "date-fns"
import { DATE_TIME_FORMAT } from "@/views/grae/ActualitesView.vue"
import H3TitleView from "@/views/commons/H3TitleView.vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import ActualiteCard from "@/pages/actualite/ActualiteCard.vue"
import LoadingSkeleton from "@/views/generic_components/LoadingSkeleton.vue"

@Component({
  components: { LoadingSkeleton, ActualiteCard, BookmarkCard, H3TitleView, InputWithValidation },
})
export default class actualitesCardsView extends Vue {
  @Prop() isLoadingData: boolean
  @Prop() title: string
  @Prop() actualites: ActualiteDTO[]

  actualiteSelected = new ActualiteDTO()
  open = false

  formatDate(date: Date): string {
    if (date) {
      return format(date, DATE_TIME_FORMAT)
    }
    return ""
  }

  openModale(actuId: string): void {
    const actuFound = this.actualites.find((a) => a.id === actuId)
    if (!actuFound) {
      return
    }
    this.actualiteSelected = actuFound
    this.open = true
  }
}
